export default {
  name: "TeSubMenu",
  props: {
    showLogo: {
      type: Boolean,
      default: false,
    },
    menu: {
      type: Object,
    },
  },
  data() {
    return {
      main_menu: {},
      menus: [],
      show: true,
      selectedItem: {},
    };
  },
  watch: {
    menu(v) {
      this.main_menu = v;
      this.menus = this.main_menu.children || [];
      this.selectMenu();
    },
  },
  created() {
    this.main_menu = this.menu;
    this.menus = this.main_menu.children || [];
    this.selectMenu();
  },

  methods: {
    selectMenu() {
      let firstMenu = this.menus.length > 0 ? this.menus[0] : {};
      firstMenu =(firstMenu.children || []).length > 0 ? firstMenu.children[0] : firstMenu;
      let selectMenu = null;
      this.menus.forEach((e) => {
        let hasChildren = (e.children || []).length > 0;
        if (!hasChildren && e.selected) {
          selectMenu = e;
        }
        (e.children || []).forEach((m) => {
          if (m.selected) {
            selectMenu = m;
          }
        });
      });

      this.selectedItem = selectMenu || firstMenu;
      this.menuItemChanged(this.selectedItem);
    },
    menuItemChanged(item) {
      let width = document.documentElement.style.getPropertyValue(
        "--submenu-origin-width"
      );
      let len = (this.menus || []).length;
      document.documentElement.style.setProperty(
        "--submenu-width",
        len > 0 ? width : "0px"
      );
      if ((item.children || []).length == 0) {
        this.toggleGroup(item);
      }

      this.selectedItem.selected = false;
      this.selectedItem = item;
      this.selectedItem.selected = true;

      this.$emit("menuItemChanged", this.selectedItem);
    },
    toggleGroup(item) {
      item.hideChildren = !item.hideChildren;
    },
  },
};
